import store from "../store/store"
import {Howl} from 'howler';

export default {
    data () {
        return {
            loading: false,
            alert: null,
        }
    },
    methods: {
        playSound(file_path) {
            var sound = new Howl({
                src: file_path,
                volume: 1,
            });
            sound.play();
        },
        flashSuccess(){
          this.playSound('sfx/success.mp3')
          window.navigator.vibrate(200)
        },
        flashError(message){
          this.playSound('sfx/error.mp3')
          window.navigator.vibrate([100,30,100,30,100])
        },
        checkIn(ticketUid) {
            this.checkInOrOut(ticketUid, 'in')
        },
        checkOut(ticketUid) {
            this.checkInOrOut(ticketUid, 'out')
        },
        checkInOrOut(ticketUid, type) {
            this.loading = true
            this.alert = null
            store.dispatch('checkTicketInOrOut', {
                path: 'ticket/check-' + type,
                uid: ticketUid
            }).then(response => {
                this.loading = false
            }, error => {
                this.alert = {
                    type: 'error',
                    text: error.response.data.error
                }
                this.flashError('QR Read but ticket not recognized')
                this.loading = false
            })
        }
    }
}